export default __webpack_public_path__ + "static/media/Automotive Application 1.5515e1c1.jpg";